import { default as notifications } from './notifications';
import { default as administration } from './administration';
import { default as userInterface } from './userInterface';

export default {
    ...notifications,
    ...administration,
    ...userInterface
};
